import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { PUBLIC_ROUTES } from '../constants/app.constants';
import { UserRole } from '../constants/roles.enum';

const STAFF_ROLES = [UserRole.DOCTOR, UserRole.RECEPTIONIST, UserRole.ADMIN];

/**
 * Restricts a route to clinic staff (doctor, receptionist, admin). Doctors and
 * receptionists additionally need QualiPass switched on for the account; admins pass
 * regardless, since they may open the page for support.
 */
export const ClinicStaffGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isUserLoggedIn()) {
    return router.createUrlTree([`/${PUBLIC_ROUTES.login}`]);
  }
  const token = auth.getDecodedToken();
  if (!STAFF_ROLES.includes(token.role as UserRole)) {
    return router.createUrlTree([auth.homeRoute()]);
  }
  if (
    (token.role === UserRole.DOCTOR || token.role === UserRole.RECEPTIONIST) &&
    token.qualipassEnabled !== true
  ) {
    return router.createUrlTree([auth.homeRoute()]);
  }
  return true;
};
